import { connectHook } from 'app/common/components/connect-hook';
import { AgentEvalEditRun } from './agent-eval-edit-run';
import { useAgentEvalEditRun } from './agent-eval-edit-run-hook';

export default connectHook(AgentEvalEditRun, useAgentEvalEditRun);
